jQuery(document).ready(function ($) {

    $("#student_programs_register").submit(function () {
        $('#phone_parents').removeAttr('required');
        $('#workshop').removeAttr('required');
    });

    $("#student_programs_register").validate({

        focusInvalid: false,

        errorPlacement: function () {
            return false;  // suppresses error message text
        },
        submitHandler: function (form) {
            form.submit();
        },
        // remove border from parent
        invalidHandler: function (event, validator) {
            var invalid = [];

            $('input[type=radio][required=required]').each(function (index, el) {
                invalid.push($(el).parent().addClass('no-border-parent'));
            });
            $('#phone_parents').attr('required', 'required');
            $('#workshop').attr('required', 'required');

            $('html, body').animate({
                scrollTop: ($(validator.errorList[0].element).offset().top - 120)
            }, 1200);
        }


    });

    $('#register_student_program .datepicker').datepicker({
        dateFormat: 'dd/mm/yy',
        minDate: 0,
        onSelect: function (dateText, inst) {
            $(".date_of_arrival").removeClass("focused");
        }

    });

    if ($('#register_student_program .datepicker').val()) {
        $('.datepicker').removeClass('hasDatepicker');


    } else {
        $(".date_of_arrival").addClass("focused");
        $('.datepicker').removeClass('hasDatepicker');
    }

    $('#register_student_program .datepicker').focusout(function () {
        if ($(this).val()) {
            $(this).removeClass("focused");
        } else {
            $(this).addClass("focused");
        }
    });

//var availableDates = ["10-4-2022", "17-4-2022", "24-4-2022", "26-6-2022","3-7-2022","10-7-2022", "17-7-2022", "2-10-2022", "9-10-2022", "16-10-2022", "23-10-2022" ];
var availableDates = [
    "9-4-2023", "16-4-2023", "23-4-2023", "30-4-2023",
    "25-6-2023", "2-7-2023", "9-7-2023","16-7-2023", "23-7-2023", "30-7-2023", "6-8-2023", "13-8-2023",
    "1-10-2023", "8-10-2023", "15-10-2023", "22-10-2023" ];

    function available(date) {
      dmy = date.getDate() + "-" + (date.getMonth()+1) + "-" + date.getFullYear();
      if ($.inArray(dmy, availableDates) != -1) {
        return [true, "av","Available"];
      } else {
        return [false,"notav","Not Available"];
      }
    }

    $('#register_student_program_cit .datepicker').datepicker({
        dateFormat: 'dd/mm/yy',
        minDate: 0,
        beforeShowDay: available,
        onSelect: function (dateText, inst) {
            $(".date_of_arrival").removeClass("focused");
        }
    });

    if ($('#register_student_program_cit .datepicker').val()) {
        $('.datepicker').removeClass('hasDatepicker');
    } else {
        $(".date_of_arrival").addClass("focused");
        $('.datepicker').removeClass('hasDatepicker');
    }

    $('#register_student_program_cit .datepicker').focusout(function () {
        if ($(this).val()) {
            $(this).removeClass("focused");
        } else {
            $(this).addClass("focused");
        }
    });

    $('#register_student_program_cit_u17 .datepicker').datepicker({
        dateFormat: 'dd/mm/yy',
        minDate: 0,
        beforeShowDay: available,
        onSelect: function (dateText, inst) {
            $(".date_of_arrival").removeClass("focused");
        }
    });

    if ($('#register_student_program_cit_u17 .datepicker').val()) {
        $('.datepicker').removeClass('hasDatepicker');
    } else {
        $(".date_of_arrival").addClass("focused");
        $('.datepicker').removeClass('hasDatepicker');
    }

    $('#register_student_program_cit_u17 .datepicker').focusout(function () {
        if ($(this).val()) {
            $(this).removeClass("focused");
        } else {
            $(this).addClass("focused");
        }
    });

//    var availableDates = ["10-4-2022", "17-4-2022", "24-4-2022", "26-6-2022","3-7-2022","10-7-2022", "17-7-2022", "2-10-2022", "9-10-2022", "16-10-2022", "23-10-2022" ];
var availableDates = [
    "9-4-2023", "16-4-2023", "23-4-2023", "30-4-2023",
    "25-6-2023", "2-7-2023", "9-7-2023","16-7-2023", "23-7-2023", "30-7-2023", "6-8-2023", "13-8-2023",
    "1-10-2023", "8-10-2023", "15-10-2023", "22-10-2023" ];

    function available(date) {
      dmy = date.getDate() + "-" + (date.getMonth()+1) + "-" + date.getFullYear();
      if ($.inArray(dmy, availableDates) != -1) {
        return [true, "av","Available"];
      } else {
        return [false,"notav","Not Available"];
      }
    }

    if ($('#email_volunteer').val()) {
        $(".email_volunteer").addClass("focused");
    } else {

    }
    $("#email_volunteer").focusin(function () {
        $(".email_volunteer").addClass("focused");
    });

    $("#email_volunteer").focusout(function () {
        if ($('#email_volunteer').val()) {
            $(".email_volunteer").addClass("focused");
        } else {
            $(".email_volunteer").removeClass("focused");
        }
    });


    if ($('#date_of_birth').val()) {
        $(".date_of_birth").addClass("focused");
    }

    $("#date_of_birth").focusin(function () {
        $(".date_of_birth").addClass("focused");
    });

    $('#date_of_birth').removeClass('hasDatepicker');


    $("#date_of_birth").focusout(function () {
        if ($('#date_of_birth').val()) {
            $(".date_of_birth").addClass("focused");
        } else {
            $(".date_of_birth").removeClass("focused");
        }
    });


    $('#student_programs_register').submit(function (ev) {
        ev.preventDefault(); // to stop the form from submitting

        var email = $("#email_volunteer").val();

        if (email === "" || validateEmail(email) && email) {
            $(".email_not_valid").removeClass("error_holder");
        }

        if (validateEmail(email) !== true && email !== "") {
            $(".email_not_valid").addClass("error_holder");
        }

        var forms = document.getElementsByTagName('form');
        for (var i = 0; i < forms.length; i++) {
            forms[i].noValidate = true;
            forms[i].addEventListener('submit', function (event) {
                //Prevent submission if checkValidity on the form returns false.
                if (!event.target.checkValidity()) {
                    event.preventDefault();
                    //Implement you own means of displaying error messages to the user here.
                    $('.custom-required ').attr('style', 'height:62px; margin-bottom: 10px; border-radius: 0px; border:1px solid red !important;');
                }
            }, false);
        }

    });


});

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
